export const environment = {
  production: true,
  hostUrl: 'https//moltoluceuw.local.siwa.vpn/',
  apiUrl: 'https://moltoluceuw-api.local.siwa.vpn/'
};
